module.exports = __webpack_public_path__ + "static/media/rejilla.e0f04acf.png";